import React from "react";
import { useState } from 'react';
import { TextBox, InputSeparator, InputSuffix } from '@progress/kendo-react-inputs';
import {Button} from "../Button/Button.jsx";
import {GridContainerFlex} from "../../layout/GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../../layout/GridFlex/GridItemFlex/GridItemFlex.jsx";

/**
 * Clearable search box component
 * @param {Object} props
 * @param {string} props.value - Current search value (required)
 * @param {function} props.onChange - Change handler function (required)
 * @param {string} [props.placeholder="Search..."] - Placeholder text
 * @param {Object} [props.style] - Additional styles
 */
export const SearchBox = ({activeSearchValue, onSearch, placeholder = "Search...", style = {}, ...otherProps }) => {
    const [internalValue, setInternalValue] = useState(activeSearchValue);
    const isDirty = internalValue !== activeSearchValue;

    if (!activeSearchValue && activeSearchValue !== "") {
        throw new Error("SearchBox: 'activeSearchValue' prop is required");
    }

    const handleChange = async (e) => {
        await setInternalValue(e.value);
    };

    const handleKeyDown = async (e) => {
        if (e.key === 'Enter') {
            await handleSearch();
        }
    };

    const handleSearch = async () => {
        await onSearch(internalValue);
    }

    const handleClear = async () => {
        if(activeSearchValue) {
            await onSearch("");
        }

        setInternalValue("")
    };

    return (
        <GridContainerFlex>
            <GridItemFlex>
                <TextBox
                    value={internalValue}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    placeholder={placeholder}
                    style={{width: "100%", ...style}}
                    suffix={() => (
                        <>
                            <InputSeparator />
                            <InputSuffix>
                                <Button
                                    disabled={!internalValue}
                                    fillMode="flat"
                                    onClick={handleClear}
                                    size="small"
                                    style={{margin: 0, padding: "0 14px", height: "100%"}}
                                >
                                    X
                                </Button>
                            </InputSuffix>
                        </>
                    )}
                    {...otherProps}
                />
            </GridItemFlex>
            <GridItemFlex>
                <Button onClick={handleSearch} disabled={!isDirty}>Search</Button>
            </GridItemFlex>
        </GridContainerFlex>
    );
};